import { colord } from "colord";
import { TASK_PRIORITY_COLORS } from "constants/staff-tasks";

export const getTaskBackgroundColorByPriority = (priority: number) => {
  const color = TASK_PRIORITY_COLORS.getFromCode(priority);
  return colord(color).alpha(0.05).toHex();
};

export const getCardBorderRadius = (position?: "first" | "last" | "single") => {
  if (position === "first") return "4px 4px 0 0";
  if (position === "last") return "0px 0px 4px 4px";
  if (position === "single") return "4px 4px 4px 4px";

  return undefined;
};
